import React from 'react';
import Navbar from './components/Navbar';
import './App.css';
import Home from './components/pages/Home';
import Aboutus from './components/pages/Aboutus';
import { BrowserRouter as Router,  HashRouter, Switch, Route } from 'react-router-dom';
import Services from './components/pages/Services';
import Products from './components/pages/Products';
import SignUp from './components/pages/SignUp';

function App() {
  return (
<Router>
    <>
        <Navbar />
        <Switch>
          <Route path='/' exact component={Home} />
          <Route path='/Aboutus' component={Aboutus} />
          <Route path='/services' component={Services} />
          <Route path='/products' component={Products} />
          <Route path='/sign-up' component={SignUp} />
          </Switch>
          <Home />
    </>
    </Router>
  );
}
export default App;


   /* 
<HashRouter>
<>
 
    <Navbar />
   
      <Route path='/' exact component={Home} />
      <Route path='/Aboutus' component={Aboutus} />
      <Route path='/services' component={Services} />
      <Route path='/products' component={Products} />
      <Route path='/sign-up' component={SignUp} />
  
</>
 </HashRouter>
);
}
*/






